'use client';

import { useParams, useRouter } from 'next/navigation';
import { Search } from '@/components/search/search';
import { useEffect, useState } from 'react';
import { getAllCategoriesQueryFn } from '@/queries/meta';
import { useQuery } from '@tanstack/react-query';

export default function SearchResultsPage() {
    const { query } = useParams();
    const router = useRouter();
    const category = decodeURIComponent(query as string);
    const [title, setTitle] = useState('');
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        setEnabled(true);
    }, []);

    const { data: categories } = useQuery({
        queryKey: ['getAllCategoriesQueryFn'],
        queryFn: getAllCategoriesQueryFn,
        enabled // workaround for usequery bug on mount
    });

    useEffect(() => {
        const decoded = decodeURIComponent(query as string).toLowerCase();
        const foundCategory = categories?.find((c) => c.slug.toLowerCase() === decoded);
        if (foundCategory) {
            setTitle(foundCategory.name);
        }
    }, [categories, query]);

    return (
        <Search
            searchTitle={title}
            defaultFilter={{ categories: [category] }}
            isDefaultFilterFixed={false}
            onDefaultFilterChanged={() => {
                router.push(`/search${window.location.search}`);
            }} />
    );
}
